import React from "react";
import GlobalStyles from "styles/GlobalStyles";
import { css } from "styled-components/macro"; //eslint-disable-line

import ComponentRenderer from "ComponentRenderer.js";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutUs from "pages/AboutUs";
import ServiceLandingPage from "demos/ServiceLandingPage";
import ContactUs from "pages/ContactUs";
import { Analytics } from '@vercel/analytics/react';

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route
            path="/components/:type/:subtype/:name"
            element={<ComponentRenderer />}
          />
          <Route
            path="/components/:type/:name"
            element={<ComponentRenderer />}
          />
          <Route path="/" element={<AboutUs />} />
          <Route path="/resources" element={<ServiceLandingPage />} />
          <Route path="/about" element={<ContactUs />} />
        </Routes>
      </Router>
      <Analytics/>
    </>
  );
}
